{
    "ChannelCode": "Código",
    "Components": {
        "MeetingEnd": {
            "FeedbackConfirmation": {
                "ExploreMoreFeatures": "Explorar más funciones",
                "ThanksMessage": "Gracias por acompañarnos,",
                "WorkingMessage": "esperamos que la traducción haya mejorado el evento para usted."
            },
            "FeedbackForm": {
                "FeedbackQuestion": "¿Cómo fue la calidad de la traducción?",
                "SessionClosedMessage": "La traducción en vivo ha finalizado.",
                "ThankYouMessage": "¡Esperamos que esto haya ayudado!"
            }
        }
    },
    "Continue": "Continuar",
    "Control": {
        "Original": "Original",
        "Spacing": "Espaciado",
        "TextSize": "Tamaño",
        "Tts": "TTS"
    },
    "Download": "Descargar",
    "Idle": "Inactivo",
    "Join": "Unirse",
    "LanguageSettings": "Idioma",
    "Live": "En curso",
    "Loading": {
        "Entering": "Entrando al canal",
        "Joining": "Uniéndose al canal"
    },
    "OK": "OK",
    "Pages": {
        "Home": {
            "EnterEventCodeMessage": "Por favor, ingresa el código del canal.",
            "InputPlaceholder": "Ingresar código del canal",
            "Title": "Sé parte. Entiéndelo todo."
        },
        "SelectLanguage": {
            "SearchEmpty": "Ningún idioma coincide",
            "SearchPlaceholder": "Buscar idioma",
            "Title": "Elige tu idioma de traducción"
        }
    },
    "Pane": {
        "CatchUp": "Ir al más reciente",
        "Source": "Original",
        "Translation": "Traducción",
        "Tts": "Texto a voz",
        "TtsShort": "TTS"
    },
    "Share": "Compartir",
    "SpeechSpeed": "Velocidad de habla",
    "Start": "Iniciar",
    "Submit": "Enviar",
    "Tips": {
        "Error": {
            "Channel": {
                "LimitExceeded": "Este canal ha alcanzado su límite de conexiones."
            }
        },
        "Icon": {
            "ScrollToBottom": "Volver al más reciente",
            "ShareLink": "Compartir enlace",
            "SpeechRate": "Ajustar velocidad de reproducción"
        }
    },
    "Toast": {
        "LanguageChanged": "Idioma de traducción: {lang}",
        "LinkCopied": "Enlace copiado",
        "SourceOff": "Original oculto",
        "SourceOn": "Original visible",
        "TtsOff": "Voz desactivada",
        "TtsOn": "Voz activada"
    },
    "Transcript": {
        "Start": "Inicio de la transcripción"
    },
    "tutorialPage": {
        "downloadOverlay": {
            "originText": "Texto Original",
            "summary": "Resumen",
            "transcript": "Transcripciones"
        },
        "translationLanguage": {
            "title": "Idioma de traducción"
        }
    }
}
